/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R7_PurposeInputs */

const tr_cerez_s3_r7_purpose = /** @type {(inputs: Cerez_S3_R7_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bot ve saldırı koruması (Cloudflare)`)
};

const en_cerez_s3_r7_purpose = /** @type {(inputs: Cerez_S3_R7_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bot and attack protection (Cloudflare)`)
};

const de_cerez_s3_r7_purpose = /** @type {(inputs: Cerez_S3_R7_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bot- und Angriffsschutz (Cloudflare)`)
};

const ru_cerez_s3_r7_purpose = /** @type {(inputs: Cerez_S3_R7_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защита от ботов и атак (Cloudflare)`)
};

/**
* | output |
* | --- |
* | "Bot and attack protection (Cloudflare)" |
*
* @param {Cerez_S3_R7_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r7_purpose = /** @type {((inputs?: Cerez_S3_R7_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R7_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r7_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r7_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r7_purpose(inputs)
	return tr_cerez_s3_r7_purpose(inputs)
});